import { I18n } from 'react-redux-i18n';
import _ from 'lodash';

import {
  AUTH_USER,
  UNAUTH_USER,
} from './types/authTypes';

import { SHOW_MESSAGE, HIDE_MESSAGE } from './types/messageTypes';

import api from '../../api';
import { SHOW_LOADING, HIDE_LOADING } from './types/loadingTypes';

export const forgotPass = data => (dispatch) => {

  dispatch({
    type: SHOW_MESSAGE,
    result: I18n.t('messages.loading'),
  });

  return new Promise((resolve, reject) => {

    api.post(`api/account/forget-password/${data.id}`, data).then(
      (response) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve(response);

      },
      (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error);

      },
    );

  });

};

export const changePass = data => dispatch => new Promise((resolve, reject) => {

  api.post(`api/account/${data.code ? 'reset-password' : 'change-password'}`, data).then(
    (response) => {

      dispatch({
        type: HIDE_MESSAGE,
        result: false,
      });

      resolve(response);

    },
    (error) => {

      dispatch({
        type: HIDE_MESSAGE,
        result: false,
      });

      reject(error);

    },
  );

});

export const setProfileImage = file => (dispatch) => {

  dispatch({
    type: SHOW_MESSAGE,
    result: I18n.t('messages.saving_data'),
  });

  return new Promise((resolve, reject) => {

    const data = new FormData();
    data.append('userphoto', file);

    return api.post('api/account/adduserphoto', data)
      .then((result) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      },
      (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

};

export const removeProfileImage = () => (dispatch) => {

  dispatch({
    type: SHOW_MESSAGE,
    result: I18n.t('messages.saving_data'),
  });

  return new Promise((resolve, reject) => {

    api.post('api/account/removeuserphoto').then(
      () => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      },
      (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      },
    );

  });

};

export const auth = credentials => dispatch => api.post('Account/LoginValidation', { RequestWrapper: { login: credentials.usuario, password: credentials.senha } })
  .then((response) => {

    const data = response.data.return;
    const user = {
      IdUser: data.idUser,
      Name: data.name,
      Login: data.login,
      userTypeId: data.userTypeId,
      Email: data.email,
      Cpf: data.cpf,
      DateCreated: data.dateCreated,
      Active: data.active,
      Password: data.password,
      access_token: data.access_Token,
      LstCompany: data.lstCompany,
    };

    localStorage.setItem('AUTH_DATA', JSON.stringify({
      user,
    }));

    dispatch({
      type: HIDE_LOADING,
    });

    dispatch({
      type: AUTH_USER,
      result: {
        user,
      },
    });

  });

export const setContext = user => (dispatch) => {

  localStorage.setItem('AUTH_DATA', JSON.stringify({
    user,
  }));

  dispatch({
    type: HIDE_LOADING,
  });

  dispatch({
    type: AUTH_USER,
    result: {
      user,
    },
  });

};

export const authFromRedirect = credentials => dispatch => api.get('LoginValidate', { params: { usuario: credentials.usuario, bearer: credentials.bearer } })
  .then((response) => {

    const data = response.data.Return;
    const user = {
      id: data.IdUsuario,
      name: data.NomeUsuario,
      email: data.Email,
      type: data.Tipo,
      group: data.Grupo,
      technical: data.Tecnico,
      campaing: data.CampanhasUsuario,
      program: data.CampanhasUsuario[0],
      access_token: data.Bearer,
      unscod: data.Unscod,
      unsnome: data.UnsNome,
    };

    localStorage.setItem('AUTH_DATA', JSON.stringify({
      user,
    }));

    dispatch({
      type: AUTH_USER,
      result: {
        user,
      },
    });

  });

export const unauth = () => (dispatch) => {

  dispatch({
    type: UNAUTH_USER,
  });

  localStorage.removeItem('AUTH_DATA');
  localStorage.removeItem('last_path');

};

export const getAuthUser = () => {

  const authData = localStorage.getItem('AUTH_DATA');

  if (authData) {

    const userData = { ...JSON.parse(authData).user };

    return userData;

  }

  return null;

};

export function saveAccount(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.saving_data'),
    });

    let request;

    if (data && data.id) request = api.put('api/Person/update-myaccount', data);

    else request = api.post('api/Person/register', data);


    return request.then(
      (response) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        return response.data;

      },
      (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        throw error.response.data;

      },
    );

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js